import { render, staticRenderFns } from "./IntellectImg.vue?vue&type=template&id=3c31c067&scoped=true&"
import script from "./IntellectImg.vue?vue&type=script&lang=js&"
export * from "./IntellectImg.vue?vue&type=script&lang=js&"
import style0 from "./IntellectImg.vue?vue&type=style&index=0&id=3c31c067&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31c067",
  null
  
)

export default component.exports